import React from 'react';
import { Pagination } from '@scuf/common';

interface IPaginationModal {
    onPageChanged: Function;
    isMobileDevice: boolean,
    totalRecord: number,
    itemPerPage: number,
    activePage: number
}

export const GridPagination = (props: IPaginationModal) => {
    return (
        <div className="allopportunity__status-btn">
            <Pagination
                expandEllipsis={true}
                totalItems={props.totalRecord}
                itemsPerPage={props.itemPerPage}
                boundaryRange={3}
                onPageChange={(page, cardsPerPage) => {
                    props.onPageChanged(page, cardsPerPage);
                }}
                activePage={props.activePage}
            />
        </div>);
}
